import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { flatMap } from 'lodash';
import FlexView, {
  FlexViewMain,
  FlexViewGrid,
} from '../../views/flexView/FlexView';
import StepHeader from '../../components/stepHeader/StepHeader';
import { PACKAGES } from '../../common/steps';
import OptionsPage from '../../common/OptionsPage';
import OptionDetails from '../../common/optionDetails/OptionDetails';
import PackageDetails from './PackageDetails';
import PackageCard from '../../common/options/packageCard/PackageCard';

const Packages = ({ packageGroups, options, bottomOffset }) => {
  const packages = flatMap(packageGroups, 'options');

  if (!packages) {
    return null;
  }

  const PackageCards = ({
    packages,
    onChange,
    isUpdating,
    selectingOption,
  }) => {
    const ANALYTICS_KEY = 'packages';

    return packages.map((option) => {
      const onDetails = () => {
        navigate(`package/${option.code}`);
      };

      return (
        <PackageCard
          key={option.code}
          option={option}
          onChange={() => {
            onChange(option);
          }}
          onDetails={onDetails}
          analyticsKey={ANALYTICS_KEY}
          isUpdating={isUpdating}
          selectingOption={selectingOption}
        />
      );
    });
  };

  const navigate = useNavigate();
  const onClose = () => {
    navigate('');
  };

  return (
    <>
      <FlexView bottomOffset={bottomOffset}>
        <FlexViewMain>
          <StepHeader step={PACKAGES} />
          <FlexViewGrid className="flex-view__packages-grid">
            <OptionsPage>
              {({ onChange, isUpdating, selectingOption }) => (
                <>
                  <PackageCards
                    packages={packages}
                    onChange={onChange}
                    isUpdating={isUpdating}
                    selectingOption={selectingOption}
                  />
                  <Routes>
                    <Route
                      path="/package/:id"
                      element={
                        <OptionDetails
                          type="package"
                          options={options}
                          onClose={onClose}
                          onSelect={(option) => {
                            onChange(option);
                            navigate('');
                          }}>
                          <PackageDetails packages={packages} />
                        </OptionDetails>
                      }
                    />
                  </Routes>
                </>
              )}
            </OptionsPage>
          </FlexViewGrid>
        </FlexViewMain>
      </FlexView>
    </>
  );
};

const mapStateToProps = (state) => {
  const { packages, options } = state.config;
  return {
    packageGroups: packages,
    options,
  };
};

export default connect(mapStateToProps)(Packages);
